/**
 * The calendar date shown next to a trip day ("12/8"), shared by the bottom day
 * navigation and the classic summary's day list.
 *
 * Kept free of Vue so it can be unit tested with plain node
 * (tests/unit/rideDayLabels.test.js).
 */

const moment = require('moment');

/**
 * The 'D/M' date of a trip day, or null when only "Day N" should be shown.
 *
 * Null once the trip is over -- a past trip reads better as days than as old
 * dates -- and when the ride's dates are missing or malformed.
 *
 * @param {object} ride       ride with start_date / end_date as 'DD-MM-YYYY'
 * @param {number} dayIndex   0-based day of the trip
 * @param {moment} [today]    for tests; defaults to now
 */
function rideDayDate(ride, dayIndex, today = moment()) {
  if (!ride || !ride.start_date || !ride.end_date) return null;
  const startDate = moment(ride.start_date, 'DD-MM-YYYY', true);
  const endDate = moment(ride.end_date, 'DD-MM-YYYY', true);
  if (!startDate.isValid() || !endDate.isValid()) return null;
  if (today.clone().startOf('day').isAfter(endDate.clone().startOf('day'))) return null;
  return startDate.clone().add(dayIndex, 'days').format('D/M');
}

module.exports = { rideDayDate };
